import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class linkPreviewService {
  constructor(private http: HttpClient) {}

  getPreview(url: string, index: number) {
    return this.http.get<any>(environment.linkPreiviewURLService + '?url=' + url);
  }
}
